import React, { useState } from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ rating, onRate, readonly = false, size = 'md' }) => {
  const [hover, setHover] = useState(0);

  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  return (
    <div className="flex items-center space-x-1" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => !readonly && onRate && onRate(star)}
          onMouseEnter={() => !readonly && setHover(star)}
          onMouseLeave={() => !readonly && setHover(0)}
          disabled={readonly}
          className={`transition-all ${!readonly ? 'cursor-pointer hover:scale-110' : 'cursor-default'}`}
          data-testid={`star-${star}`}
        >
          <Star
            className={`${sizes[size]} transition-colors ${
              star <= (hover || rating)
                ? 'text-electric fill-electric'
                : 'text-foreground/30'
            }`}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
